import React from "react";
import { getApproximateCost, updateApproximateCost } from "../../services/admin/action";
import { connect } from "react-redux";
import Model from '../common/model';

class AppCostUpdate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

            approximateCost: "",
            openPopup: false,
            model_text: "",
            approximateKey: ""

        }
    }

    componentDidMount() {
        let access_token = this.props.loginDetails;
        let userType = this.props.profileDetails.commonUser.userType

        this.setState({
            access_token,
            userType
        })
      
        this.props.getApproximateCost(access_token);

    }
    componentWillReceiveProps = nextProps => {
        if(nextProps.getApproximateCostDetails){
        let data = nextProps.getApproximateCostDetails.propertyDetails;
        this.setState({
            approximateCost: data.value,
            approximateKey: data.key,
            id: data.id,
        })
    }
}
    updateCost = (e) => {
        e.preventDefault();
        document.body.classList.add('modal-open');
        this.setState({
            openPopup: true,
            model_text: "Are you sure you want to update cost"
        })
    }
    closePop = () => {
        document.body.classList.remove('modal-open');

        this.setState({
            openPopup: false
        })
    }

    changeCost = (cost) => {
        document.body.classList.remove('modal-open');
        this.setState({
            openPopup: false,
            approximateCost: cost
        })
        let payLoad = {
            "id": this.state.id,
            "key": this.state.approximateKey,
            "value": cost

        }
        let access_token = this.props.loginDetails;

     
        this.props.updateApproximateCost(access_token, payLoad)

    }

    render() {

        
        return (
            <React.Fragment>
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                    <div className="form-group">
                    <div className="title-text">
                        <label> Approximate Cost</label></div>
                        <div className="amount-display">
                        <h2>{this.state.approximateCost} </h2>
                      
                       

                    </div>
                    <button type="submit" className="loginbtn-submitt green" onClick={this.updateCost}>Change</button>
                        </div>

                </div>
                {this.state.openPopup &&
                    <Model header="Update Approximate Cost" change={this.changeCost} page="costUpdate" text={this.state.model_text} cost={this.state.approximateCost} status={this.state.openPopup} closePop={this.closePop} />
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    getApproximateCostDetails: state.adminReducer.getApproximateCostDetails,

});

const mapDispatchToProps = dispatch => ({
    getApproximateCost: token => dispatch(getApproximateCost(token)),
    updateApproximateCost: (token,payload) => dispatch(updateApproximateCost(token,payload))

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppCostUpdate);